









import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
import Helpers from '../mixins/helpers';
import Api from '../mixins/api';
import Sliders from '@/components/dumb/Sliders.vue';
import RateDisclaimer from '@/components/RateDisclaimer.vue';
import Analytics from '@/mixins/analytics';
export default Vue.extend({
	name: 'SlidersFinance',
	components: {
		Sliders, 
		RateDisclaimer
	},
	props: {
		postNow: {
			type: Boolean
		}
	},
	data(): any {
		return {
			financeSliderTouched: false
		};
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			finance(): any { return this.$store.state.finance },
			tpr(): any { return this.$store.state.tpr },
			dealer(): any { return this.$store.state.dealer },
			vehicle(): any { return this.$store.state.vehicle },
			customer(): any { return this.$store.state.customer }
		}), 
		flow(): string {
			return this.$store.getters.flow;
		},
		vehicleFinalPrice(): number {
            return this.$store.getters.vehicleFinalPrice;
        },
		enableFinanceValues(): boolean {
            return this.financeSliderTouched || this.flow != 'indicative';
        },
		slidersFinance(): Array<any> {
			return [
				{
					id: 0, 
					type: 'currency', 
					title: 'Deposit', 
					description: 'Tell us the amount of money you would like to pay upfront to calculate your regular repayments.', 
					min: this.dealer.depositMinimum, 
					max: this.finance.maxFinanceDeposit, 
					interval: 50, 
					val: this.app.financeDeposit
				}, 
				{
					id: 1,
					type: 'int',
					title: 'Loan term (in years)', 
					description: 'Decide what time period you would like to pay off your loan.',
					disabled: !this.enableFinanceValues, 
					min: 1, 
					max: this.vehicle.initialFinanceSetting.TermInYears, 
					val: this.app.loanTerm
				}, 
				{
					id: 2,
					type: 'distance',
					title: 'Estimated km/yr', 
					description: 'Please estimate the number of kilometres you drive each year so we can calculate your Toyota’s Guaranteed Future Value.',
					disabled: !this.enableFinanceValues, 
					min: 10000, 
					max: 50000, 
					data: [
						10000,
						15000,
						20000,
						30000,
						40000,
						50000
					],
					val: this.app.kmsPerYear
				}
			];
		}, 
	}, 
	methods: {
		postLeadStart(): void {
			Api.postLeadStart((response: any) => {
				Helpers.clog('setting tprLeadId ' + response.data.OrderNumber);
				this.$store.commit('setTpr', {leadId: response.data.OrderNumber});
			});
		},
		postLeadEnd(): void {
			Api.postLeadEnd();
		}, 
		handleSliderAnalytics(o: any): void {
			Helpers.clog(o);
			switch (o.id){
				case 0:
					Analytics.sendEvent({
						'event': 'adjustTPRDeposit',
						'depositAmount': o.val
					});
					break;
				case 1:
					Analytics.sendEvent({
						'event': 'adjustLoanTerm',
						'loanTerm': o.val * 12
					});
					break;
				case 2:
					Analytics.sendEvent({
						'event': 'adjustKLMPA',
						'estKLMPerAnnum': o.val
					});
					break;
			}
			
		}, 
		handleSliderUpdate(data: any): void {
			Helpers.clog('updating sliders');
			const sliders = data.data;
			const analytics = data.analytics;
			let deposit = '';
			let term = '';
			let kms = '';
			let hasChanged = false;
			for (let i = 0; i != sliders.length; ++i){
				const s = sliders[i];
				switch (s.id){
					case 0:
						deposit = s.val;
						if (this.app.financeDeposit != s.val){
							hasChanged = true;
							this.$store.commit('setApp', {
								financeDeposit: s.val
							});
						}
						break;
					case 1:
						term = s.val;
						if (this.app.loanTerm != s.val){
							hasChanged = true;
							this.$store.commit('setApp', {
								loanTerm: s.val
							});
						}
						break;
					case 2:
						kms = s.val;
						if (this.app.kmsPerYear != s.val){
							hasChanged = true;
							this.$store.commit('setApp', {
								kmsPerYear: s.val
							});
						}
						break;
				}
			}
			if (hasChanged && deposit && term && kms){
				const dateexp = new Date(this.tpr.validityDate);
				const expires = "expires="+ dateexp.toString();
				const cookieData = ";" + expires + ';path=/';
				document.cookie = "financeoptions=" + deposit +'_' + term + '_' + kms + cookieData;
				Helpers.clog('set cookies with ' + cookieData);
				this.postUpdatedFinance(analytics);
			}
		}, 
		postUpdatedFinance(analytics: any): void {
			const dealer: any = (window as any).StoreWebsiteInfo;
			const queryDealerID: number = dealer.StockDealerID === 0 ? dealer.DealerID : dealer.StockDealerID;
			const financeCalculationURL = Api.getFinanceCalculationURL(
				this.vehicleFinalPrice, 
				this.app.financeDeposit, 
				this.app.loanTerm * 12, 
				this.app.kmsPerYear, 
				queryDealerID, 
				this.vehicle.vehicleSpecificationID, 
				this.vehicle.termOffset, 
				this.vehicle.materialCode, 
				this.vehicle.produced, 
				this.tpr.guestRateIdentifier, 
				this.customer.orderType
			);
			this.$store.commit('setApp', {isFinanceLoading: true});
			Helpers.clog(financeCalculationURL);
			axios.get(financeCalculationURL).then((response: any) => {
				Helpers.clog(response.data);
				if (response.data.WasFinanced){
					const financeData = Api.processFinanceResponse(response.data);
					this.$store.commit('setFinance', financeData);
					this.$store.dispatch('removeDisclaimer', 'finance');
					this.$store.commit('addDisclaimer', {
						type: "finance", 
						for: 'finance',
						key: '',
						text: financeData.disclaimer
					});
					this.$store.commit('setApp', {
						financeDeposit: financeData.financeDeposit, 
						maxFinanceDeposit: financeData.maxFinanceDeposit
					});
					if (!this.tpr.validityDate) {
						this.$store.commit('setTpr', {
							validityDate: financeData.rateExpiry
						});
					}
					analytics && this.handleSliderAnalytics(analytics);
				} 
				else {
					this.$store.commit('setApp', {isFinanceAvailable: false});
					this.$store.commit('setError', {
						message: `Sorry, this vehicle cannot be financed.`,
						buttons: [{
							title: this.app.webkiosk ? 'Go Home' : `Back to ${dealer.locationName}`,
							callback: () => {
								location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
							}
						}, {
							title: 'Close'
						}]
					});
				}
				this.$store.commit('setApp', {isFinanceLoading: false});
				this.financeSliderTouched = true;
				if (this.flow == 'adjust-tpr' && !this.tpr.hasLoadedWithTpr){
					this.postLeadStart();
				}
				this.$emit('update');
			}).catch((response: any) => {
				Helpers.clog(response);
				this.$store.commit('setApp',{
					isFinanceAvailable: false, 
					isFinanceLoading: false, 
					loanTerm: this.app.loanTermBackUp, 
					kmsPerYear: this.app.kmsPerYearBackUp
				});
				this.$store.commit('setError', {
					message: `Sorry, the finance details could not be loaded.`,
					buttons: [{
						title: this.app.webkiosk ? 'Go Home' : `Back to ${dealer.locationName}`, 
						callback: () => {
							location = this.app.webkiosk ? this.app.webkioskurl : this.dealer.nviUrl
						}
					}, {
						title: 'Close'
					}]
				});
			});    
        }
	}, 
	mounted(): void {
		if (this.postNow){
			this.postUpdatedFinance();
		}
	}, 
	beforeDestroy(): void {
		this.postLeadEnd();
	}
});
